import { ListingFooterViewModel } from 'models';

export const isMemberOnlyDealListingFooter = (listingFooter?: ListingFooterViewModel) =>
  listingFooter?.actionModel.actionDetails?.name === 'EXTERNAL_LINK';
